<template>
  <sz-table :columns="columns" :table-data="tableData" ref="table"></sz-table>
</template>

<script>
import szTable from "@/components/szTable/szTable.vue";
import dayjs from "dayjs";

export default {
  name: "device-table",
  components: { szTable },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns: [
        { field: "code", label: "设备编号" },
        { field: "name", label: "设备名称" },
        {
          field: "model",
          label: "设备模板",
          render: (h, { row }) => {
            return h("span", row.o_model.name);
          },
        },
        {
          field: "time",
          label: "上传时间",
          render: (h, { row }) => {
            return h("span", dayjs.unix(row.time).format("HH:mm"));
          },
        },
        {
          field: "online",
          label: "在线情况",
          render: (h, { row }) => {
            return h(
              "span",
              {
                style: {
                  borderColor: row?.online === 1 ? "#e1f3d8" : "#fef0f0",
                  color: row?.online === 1 ? "#f0f9eb" : "#fde2e2",
                  backgroundColor: row?.online === 1 ? "#67c23a" : "#F56C6C",
                  padding: "5px 10px",
                  borderRadius: "5px",
                },
              },
              row?.online === 1 ? "在线" : "离线"
            );
          },
        },
      ],
    };
  },
  methods: {},
  watch: {
    tableData() {
      this.$refs.table.doLayout();
    },
  },
};
</script>

<style scoped lang="less"></style>
